import { businessProfileCreationSuccess } from 'lib/common/messages';
import addMessage from 'action-creators/messaging/add-message';

export default function createBusinessProfileSuccess() {
  return addMessage(businessProfileCreationSuccess);
}
